var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Facebbock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-facebbock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7355",
    "data-name": "Rectangle 7355",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11014",
    "data-name": "Path 11014",
    d: "M19.167,11.138A9.583,9.583,0,1,0,8.086,20.605v-6.7H5.653v-2.77H8.086V9.027A3.382,3.382,0,0,1,11.706,5.3a14.737,14.737,0,0,1,2.145.187V7.844H12.643a1.385,1.385,0,0,0-1.562,1.5v1.8h2.658l-.425,2.77H11.081v6.7A9.586,9.586,0,0,0,19.167,11.138Z",
    transform: "translate(2 0.445)",
    fill: "#adb5b9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Facebbock);
export default __webpack_public_path__ + "static/media/icon-24-facebbock.334ab6e5c9d2f687cd5f3bd1847ec69a.svg";
export { ForwardRef as ReactComponent };